import React, { useState } from "react";
import { motion } from "framer-motion";
import {
  Grid,
  TextField,
  Button,
  MenuItem,
  Switch,
  FormControlLabel,
  Card,
  CardContent,
} from "@mui/material";
import dayjs from "dayjs";
import SaveIcon from "@mui/icons-material/Save";
import UpdateIcon from "@mui/icons-material/Update";
import RotateLeftIcon from "@mui/icons-material/RotateLeft";
import configServ from "../../services/config";
import { useSelector } from "react-redux";
import toast from "react-hot-toast";

// 🔹 Dummy service (replace with your real service)
const holidayService = {
  createHoliday: async (payload) => {
    console.log("CREATE API", payload);
  },
  updateHoliday: async (payload) => {
    console.log("UPDATE API", payload);
  },
};

const HolidayCard = ({
  isEdit,
  editData,
  fetchHolidayList,
  handlePopup,
  setEditId,
  editId,
  setEditData,
  setisEdit,
}) => {
  const { company_id } = useSelector((state) => state.GlobalVariables);

  // 🔹 Form State
  const [formData, setFormData] = useState({
    holiday_date: "",
    title: "",
    holiday_type: "global",
    active: true,
  });

  React.useEffect(() => {
    if (editData && isEdit) {
      setFormData({
        holiday_date: dayjs(editData.holiday_date).format("YYYY-MM-DD"),
        title: editData.title || "",
        holiday_type: editData.holiday_type || "global",
        active: editData.active ?? true,
      });
    }
  }, [editData, isEdit]);

  // 🔹 Handle Change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // 🔹 Handle Switch
  const handleSwitch = (e) => {
    setFormData((prev) => ({
      ...prev,
      active: e.target.checked,
    }));
  };

  // 🔹 Clear Form
  const clear = () => {
    setFormData({
      holiday_date: "",
      title: "",
      holiday_type: "global",
      active: true,
    });
    setEditId(null);
    setEditData(null);
    setisEdit(false);
  };

  // 🔹 Submit Handler
  const handleSubmit = async () => {
    const payload = {
      ...formData,
      company_id: company_id,
    };

    try {
      if (isEdit) {
        const result = await configServ.updateHoliday(editId, payload);
        if (result.status) {
          toast.success(result.message);
          handlePopup();
          setEditId(null);
          fetchHolidayList();
        }
      } else {
        const result = await configServ.createHoliday(payload);
        if (result.status) {
          toast.success(result.message);
          handlePopup();
          setEditId(null);
          fetchHolidayList();
        }
      }
      clear();
    } catch (error) {
      console.error("Holiday submit error", error);
    }
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 15 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
      style={{ width: "100%", padding: "16px" }}
    >
      <Card>
        <CardContent>
          <Grid container spacing={2}>
            {/* Holiday Date */}
            <Grid item xs={12} md={3}>
              <TextField
                fullWidth
                type="date"
                label="Holiday Date"
                name="holiday_date"
                value={formData.holiday_date}
                onChange={handleChange}
                InputLabelProps={{ shrink: true }}
                size="small"
              />
            </Grid>

            {/* Title */}
            <Grid item xs={12} md={4}>
              <TextField
                fullWidth
                label="Title"
                name="title"
                value={formData.title}
                onChange={handleChange}
                size="small"
              />
            </Grid>

            {/* Holiday Type */}
            <Grid item xs={12} md={3}>
              <TextField
                select
                fullWidth
                label="Holiday Type"
                name="holiday_type"
                value={formData.holiday_type}
                onChange={handleChange}
                size="small"
                // disabled={true}
              >
                <MenuItem value="global">Global</MenuItem>
                <MenuItem value="batch">Batch</MenuItem>
              </TextField>
            </Grid>

            {/* Active Status */}
            <Grid item xs={12} md={2}>
              <FormControlLabel
                control={
                  <Switch checked={formData.active} onChange={handleSwitch} />
                }
                label="Active"
              />
            </Grid>

            {/* Action Buttons */}
            <Grid item xs={12}>
              <Grid container spacing={2} justifyContent="flex-end">
                <Grid item>
                  <Button
                    color="secondary"
                    onClick={clear}
                    variant="contained"
                    startIcon={<RotateLeftIcon />}
                  >
                    Reset
                  </Button>
                </Grid>

                <Grid item>
                  <Button
                    color={isEdit ? "success" : "primary"}
                    onClick={handleSubmit}
                    variant="contained"
                    startIcon={isEdit ? <UpdateIcon /> : <SaveIcon />}
                  >
                    {isEdit ? "Update" : "Save"}
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </motion.div>
  );
};

export default HolidayCard;
